import { Link } from "react-router-dom";
import { packages } from "@/data/services";

const PackagesSection = () => (
  <section id="packages" className="bg-[#f7f7f7] py-16 md:py-24">
    <div className="container">
      <h2 className="text-3xl md:text-4xl font-black text-dark text-center mb-4">
        High-Value Property Upgrade Packages
      </h2>
      <p className="text-center text-muted-foreground mb-14 max-w-xl mx-auto">
        Bundle multiple services together for a cleaner result and better value.
      </p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {packages.map((p) => (
          <div
            key={p.title}
            className="bg-white rounded-xl p-7 shadow-[0_2px_16px_rgba(0,0,0,0.05)] hover:shadow-lg transition-shadow flex flex-col"
          >
            <div className="w-12 h-12 bg-yellow/15 rounded-full flex items-center justify-center mb-5">
              <p.icon className="w-6 h-6 text-dark" />
            </div>
            <h3 className="text-xl font-bold text-dark mb-2">{p.title}</h3>
            <p className="text-muted-foreground leading-relaxed mb-4">{p.desc}</p>
            <ul className="text-sm text-muted-foreground space-y-1.5 mb-6 flex-1">
              {p.includes.slice(0, 4).map((i) => (
                <li key={i} className="flex gap-2">
                  <span className="text-yellow font-bold">•</span>
                  {i}
                </li>
              ))}
            </ul>
            <Link
              to="/get-quote"
              className="mt-auto inline-block text-center bg-[#1a1a1a] text-[#FFC300] px-6 py-3 font-bold rounded-md hover:opacity-90 transition-opacity"
            >
              Request a Quote
            </Link>
          </div>
        ))}
      </div>
      <div className="mt-12 text-center">
        <Link
          to="/packages"
          className="inline-block border-2 border-[#1a1a1a] text-[#1a1a1a] px-8 py-4 text-lg font-bold rounded-md hover:bg-[#1a1a1a]/5 transition-colors"
        >
          View All Packages
        </Link>
      </div>
    </div>
  </section>
);

export default PackagesSection;
